<mat-dialog-content xmlns="http://www.w3.org/1999/html">
  <h2>{{"admin.countries.edit" | translate}} {{"admin.users.user" | translate}}</h2>
  <mat-card-content>
    <form (submit)="sendEditionForm()" [formGroup]="userEditForm" autocomplete="off">
      <div class="form-container">
        <mat-form-field appearance="fill">
          <mat-label>{{"admin.countries.first-name" |translate}}</mat-label>
          <input [formControl]="firstNameControl" matInput type="text">
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>{{"admin.countries.last-name" |translate}}</mat-label>
          <input [formControl]="nameControl" matInput type="text">
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>{{"admin.users.email" |translate}}</mat-label>
          <input [formControl]="emailControl" matInput type="text" pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}">
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>{{"admin.users.function" |translate}}</mat-label>
          <input [formControl]="functionControl" matInput type="text">
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>{{"admin.weee-system.role" | translate}}</mat-label>
          <mat-select [formControl]="roleControl">
            <mat-option *ngFor="let role of data.roles" [value]="role.code">{{role.name}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" *ngIf="roleControl.value !== 'WF_ADMIN' && roleControl.value !== ''">
          <mat-label>{{"admin.weee-system.weee-system" | translate}}</mat-label>
          <mat-select [formControl]="weeeSystemControl">
            <mat-option *ngFor="let ws of data.weeeSystems" [value]="ws.id">{{ws.description}}</mat-option>
          </mat-select>
        </mat-form-field>

        <div class="edit-dialog-buttons-container">
          <button mat-raised-button (click)="closeDialog()" type="button" >
            <span>Close</span>
          </button>
          <button [disabled]="userEditForm.get('name')?.invalid ||
                              userEditForm.get('email')?.invalid ||
                              userEditForm.get('role')?.invalid ||
                              (roleControl.value !== 'WF_ADMIN' && roleControl.value !== '' ? userEditForm.get('weeeSystem')?.invalid : false)"
                  mat-raised-button color="primary" type="submit">
            <span>Save</span>
          </button>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-dialog-content>
